// Generated by ReScript, PLEASE EDIT WITH CARE


function getUrlWithLocale(locale_code, path, default_localeOpt) {
  var default_locale = default_localeOpt !== undefined ? default_localeOpt : "";
  if (locale_code === default_locale) {
    if (path.length === 1) {
      return "/";
    } else {
      return "" + path + "";
    }
  } else {
    return "/" + locale_code + "" + path + "";
  }
}

function getEndpointWithCountryCode(endpoint, country_code, is_collectionOpt) {
  var is_collection = is_collectionOpt !== undefined ? is_collectionOpt : false;
  return "" + endpoint + "-bd" + (
          is_collection ? "s" : ""
        ) + "";
}

export {
  getUrlWithLocale ,
  getEndpointWithCountryCode ,
}
/* No side effect */
